import { useState, useEffect, useCallback } from 'react';

export const useDarkMode = (initialValue = true) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            const item = window.localStorage.getItem('darkMode');
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error("Error reading from localStorage", error);
            return initialValue;
        }
    });

    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            document.documentElement.style.backgroundColor = '#100f15';
        } else {
            document.documentElement.classList.remove('dark');
            document.documentElement.style.backgroundColor = '#f8fafc'; // slate-50
        }

        try {
            window.localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        } catch (error) {
            console.error("Error writing to localStorage", error);
        }
    }, [isDarkMode]);

    const toggleDarkMode = useCallback(() => {
        setIsDarkMode(prevMode => !prevMode);
    }, []);

    return [isDarkMode, toggleDarkMode];
};